import { C } from '../constants/dashboardConstants';

export default function ComingSoonBox({ minHeight = '500px' }) {
  return (
    <div style={{
      flex: 1,
      border: `1px solid ${C.g200}`,
      borderRadius: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      background: '#fff',
      minHeight,
    }}>
      <div style={{
        fontSize: '32px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        fontFamily: 'Pretendard, sans-serif',
        color: '#090909',
      }}>
        Coming Soon
      </div>

      {/* <div style={{
        fontSize: '16px',
        letterSpacing: '0.06em',
        fontFamily: 'Pretendard, sans-serif',
        color: '#A2A2A2',
      }}>
        슛 들어가기 전입니다!
      </div> */}

      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        color: '#555', fontSize: '12px', letterSpacing: '0.15em',
        fontFamily: 'Pretendard, sans-serif', marginTop: '8px',
      }}>
        <span style={{
          display: 'inline-block',
          width: '6px', height: '6px', borderRadius: '50%',
          background: '#ff3b3b',
          animation: 'blink 1s infinite',
        }} />
        REC
      </div>

      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
      `}</style>
    </div>
  );
}
